<template>
  <div class="mobile-content3">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">酒吧获客，收益多多</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="card-show-container">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
      >
        <div
          v-if="card.cardTitle"
          class="title-container"
        >
          {{ card.cardTitle }}
        </div>
        <div class="card-image">
          <img
            v-if="card.cardImage"
            :src="card.cardImage"
            :alt="card.cardTitle"
          />
        </div>
        <div class="card-content">
          {{ card.cardContent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileContent3',
  data() {
    return {
      cardList: [
        {
          cardTitle: '祝福上墙，礼物收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/lwsy_1768989490255f29cef.webp',
          cardContent: 'Flask酒吧礼物收益数据',
        },
        {
          cardTitle: '土豪霸屏，打赏收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/dxsy_176898949025613bcd0.webp',
          cardContent: '麦坊酒吧打赏收益数据',
        },
        {
          cardTitle: '扫码点歌，表演收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/bysy_17689894902567744f3.webp',
          cardContent: '醉东酒吧表演收益数据',
        },
        {
          cardTitle: '互动摇骰，游戏收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/yxsy_1768989490255fa7f97.webp',
          cardContent: 'E.P.I.C.酒吧游戏收益数据',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.mobile-content3 {
  width: 100%;
  margin-top: 64px;

  .title-container {
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 26px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .card-show-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;
    margin-top: 32px;

    .card {
      width: 315px;
      height: 349px;
      border-radius: 12px;
      border: 2px solid #C95EFB;
      background: linear-gradient(
        90deg,
        rgba(88, 36, 222, 0.8) 0%,
        rgba(167, 70, 209, 0.8) 98.57%
      );
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;

      .title-container {
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 276px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 1.2;
        background-image: url('~@/assets/image/card-title.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
      }

      .card-image {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 60px;

        img {
          width: 281px;
          height: 229px;
          display: block;
          object-fit: contain;
        }
      }

      .card-content {
        margin-top: auto;
        margin-bottom: 24px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        white-space: nowrap;

        &::before,
        &::after {
          content: '';
          display: block;
          flex: 1;
          height: 1px;
          background: #FFFFFF;
          opacity: 0.8;
          margin: 0 12px;
        }
      }
    }
  }
}
</style>
